<div class="thumbnail-wrapper">
  @if (!shouldShowFallbackIcon()) {
    <img
      [src]="src"
      alt=""
      (load)="isLoaded = true"
      class="has-thumbnail"
      [attr.crossorigin]="determineCrossOriginValue()"
      />
  } @else {
    <i class="{{fallbackIcon}} no-thumbnail"></i>
  }


  @if (duration > 0) {
    <div class="duration">
      <span class="cover"></span>
      <span class="text">{{duration | formatTime}}</span>
    </div>
  }
</div>
